import { Component, OnInit } from "@angular/core";
import { DashboardItemsRestService } from "./dashboard-items.rest";
import { DashboardItem, DashboardShortcut } from "./dashboard-items.model";
import { Router } from "@angular/router";

@Component({
  selector: 'app-dashboard-items',
  templateUrl: './dashboard-items.component.html'
})
export class DashboardItemsComponent implements OnInit {

  public items: DashboardItem[];
  public shortcuts: DashboardShortcut[];

  constructor(
    private rest: DashboardItemsRestService,
    private router: Router
  ) { }

  ngOnInit() {
    this.rest.GetDashboardItems().subscribe(result => {
      if (result) {
        this.items = result.dashboardItems;
        this.shortcuts = result.dashboardShortcuts;

        this.items.forEach(item => {
          if (item.objectPath) {
            let parts = item.objectPath.split('?', 2);
            let parsedRoute = this.router.parseUrl(item.objectPath);
            let queryParams = parts.length > 1 ? parsedRoute.queryParams : null;
            item.routingPath = { path: parts[0], queryParams: queryParams }
          } else {
            item.routingPath = { path: null, queryParams: null }
          }
        });

        if (this.shortcuts) {
          this.shortcuts.forEach(shortcut => {
            let parts = shortcut.objectPath.split('?', 2);
            let parsedRoute = this.router.parseUrl(shortcut.objectPath);
            let queryParams = parts.length > 1 ? parsedRoute.queryParams : null;
            shortcut.routingPath = { path: parts[0], queryParams: queryParams }
          });
        }
      }
    });
  }

}
